import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import {
  getTowlotVehicles as getTowlotVehiclesAction,
  getTowlotVehicle as getTowlotVehicleAction,
  clearLocalTowlotVehicles as clearLocalTowlotVehiclesAction,
  clearLocalActiveTowlotVehicle as clearLocalActiveTowlotVehicleAction,
  createTowlotVehicle as createTowlotVehicleAction,
  retryTowlotVehicle as retryTowlotVehicleAction,
  getAuctionTowlotVehicles as getAuctionTowlotVehiclesAction,
  clearLocalAuctionTowlotVehicles as clearLocalAuctionTowlotVehiclesAction
} from 'actions/towlotVehicles';

const useTowlotVehicles = () => {
  const dispatch = useDispatch();
  const getTowlotVehicles = useCallback((payload) => dispatch(getTowlotVehiclesAction(payload)), [dispatch]);
  const getTowlotVehicle = useCallback((id) => dispatch(getTowlotVehicleAction(id)), [dispatch]);
  const clearLocalTowlotVehicles = useCallback(() => dispatch(clearLocalTowlotVehiclesAction()), [dispatch]);
  const clearLocalActiveTowlotVehicle = useCallback(() => dispatch(clearLocalActiveTowlotVehicleAction()), [dispatch]);
  const createTowlotVehicle = useCallback((payload) => dispatch(createTowlotVehicleAction(payload)), [dispatch]);
  const retryTowlotVehicle = useCallback((payload) => dispatch(retryTowlotVehicleAction(payload)), [dispatch]);
  const getAuctionTowlotVehicles = useCallback((payload) => dispatch(getAuctionTowlotVehiclesAction(payload)), [dispatch]);
  const clearLocalAuctionTowlotVehicles = useCallback(() => dispatch(clearLocalAuctionTowlotVehiclesAction()), [dispatch]);

  return {
    getTowlotVehicles,
    getTowlotVehicle,
    clearLocalTowlotVehicles,
    clearLocalActiveTowlotVehicle,
    createTowlotVehicle,
    retryTowlotVehicle,
    getAuctionTowlotVehicles,
    clearLocalAuctionTowlotVehicles
  };
};

export default useTowlotVehicles;
